import { render, staticRenderFns } from "./OrderItemView.vue?vue&type=template&id=df6b2206&scoped=true&"
import script from "./OrderItemView.vue?vue&type=script&lang=js&"
export * from "./OrderItemView.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemView.vue?vue&type=style&index=0&id=df6b2206&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df6b2206",
  null
  
)

export default component.exports